import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import BrandWordmark from './BrandWordmark';

const Header = ({ setSection, clearSelections }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    setSection('Dashboard');
    clearSelections();
    navigate('/dashboard');
  };

  return (
    <header className="app-header px-2 mb-1">
      <div className="logo-section" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <BrandWordmark size="lg" />
      </div>
    </header>
  );
};

export default Header;
